// Utility to set/update favicon dynamically based on project brand configuration
import brandConfig from '../../config/chooseBrand';

function guessTypeFromHref(href) {
    if (!href) return undefined;
    if (href.endsWith('.png')) return 'image/png';
    if (href.endsWith('.jpg') || href.endsWith('.jpeg')) return 'image/jpeg';
    if (href.endsWith('.ico')) return 'image/x-icon';
    if (href.endsWith('.svg')) return 'image/svg+xml';
    return undefined;
}

function updateOrCreateLink(rel, href, opts = {}) {
    if (!href) return null;
    let el = document.querySelector(`link[rel="${rel}"]`);
    if (!el) {
        el = document.createElement('link');
        el.rel = rel;
        document.head.appendChild(el);
    }
    el.href = href;
    if (opts.type) el.type = opts.type;
    return el;
}

export default function applyBrandFavicon() {
    try {
        const bc = brandConfig && typeof brandConfig === 'function' ? brandConfig() : null;
        const logo = bc?.config?.favicon;
        // prefer an explicit favicon path on the brand config if provided
        const faviconCandidate = bc?.config?.favicon || logo || '/assets/icons/favicon-32x32.png';

        const type = guessTypeFromHref(faviconCandidate);

        // Set common rels so browsers pick it up
        updateOrCreateLink('icon', faviconCandidate, { type });
        updateOrCreateLink('shortcut icon', faviconCandidate, { type });
        updateOrCreateLink('apple-touch-icon', faviconCandidate);

        // Optionally update the manifest link if a brand-specific manifest is provided
        if (bc?.config?.manifest) {
            updateOrCreateLink('manifest', bc.config.manifest);
        }
    } catch (e) {
        // non-fatal; don't break the app if favicon logic fails
        // eslint-disable-next-line no-console
        console.warn('applyBrandFavicon failed', e);
    }
}
